/** Догружает все страницы offset-пагинации (`page` + `count`). */
export async function fetchAllByPage<T>(
  fetchPage: (page: number, count: number) => Promise<T[]>,
  pageSize: number,
): Promise<T[]> {
  const items: T[] = [];
  let page = 1;

  while (true) {
    const batch = await fetchPage(page, pageSize);
    if (batch.length === 0) break;
    items.push(...batch);
    page += 1;
  }

  return items;
}

/** Догружает cursor-пагинацию (`nextId` + `count`), например ответы Яндекс-форм. */
export async function fetchAllByCursor<T>(
  fetchBatch: (
    nextId: string | undefined,
    count: number,
  ) => Promise<{ data: T[]; nextId?: string | null }>,
  pageSize: number,
): Promise<T[]> {
  const items: T[] = [];
  let nextId: string | undefined;
  const seenCursors = new Set<string>();

  while (true) {
    const response = await fetchBatch(nextId, pageSize);
    const batch = response.data ?? [];
    items.push(...batch);

    const cursor = response.nextId?.trim();
    if (batch.length === 0 || !cursor || seenCursors.has(cursor)) break;
    seenCursors.add(cursor);
    nextId = cursor;
  }

  return items;
}
